import * as React from "react";
import { Image } from "react-native";
import { Text } from "react-native-paper";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import windowWidth from "../../common/windowWidth";
import { blackColor, whiteColor } from "../../common/colors";

export default (props) => {
  return (
    <TouchableOpacity onPress={props.onPress} style={styles.wrapper}>
      <View style={styles.container}>
        <View style={styles.wrapper66}>
          <Text style={styles.textStyle}>{props.children}</Text>
        </View>
        <View style={styles.wrapper33}>
          <Image source={props.source} style={styles.image} />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const width = (windowWidth() - 80) / 5;

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    backgroundColor: "#DDDDDD",
    padding: 10,
  },
  wrapper: {
    width: "100%"
  },
  wrapper66: {
    width: "66%",
    alignItems: "flex-start",
    paddingLeft: 50,
  },
  wrapper33: {
    width: "33%",
    alignItems: "flex-end",
    height: "100%",
  },
  container: {
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    borderWidth: 0.5,
    marginBottom: 5,
    marginTop: 5,

    width: '100%',
    height: 104,
    flexDirection: "row",
    backgroundColor: whiteColor,
  },
  textStyle: {
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 26,
    letterSpacing: 1.25,
    padding: 20,
    color: blackColor,
  },
  image: {
    marginTop: 0,
    height: 104,
    width: 141,
    // resizeMode: "contain",
  },
});
